import Button from '@/components/Buttons/Button';
import { pricingStudioUrl } from '@/environment';
import styled from '@emotion/styled';
import { Popover, Typography } from '@mui/material';

const styles = {
    paper: {
        width: '265px',
        padding: '16px',
        boxShadow: '5.3px 13.3px 18.8px -1.2px rgba(187, 187, 187, 0.29) !important',
        pointerEvents: 'auto',
        userSelect: 'none',
    },
};

const Title = styled(Typography)`
    margin-bottom: 0.8rem;
    letter-spacing: -0.04rem;
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
`;

const ExploreButton = styled(Button)`
    font-size: 1.4rem;
    height: 3.4rem;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
`;

interface Props {
    anchorEl: null | HTMLElement;
    open: boolean;
    onMouseEnter: () => void;
    onMouseLeave: () => void;
}

export default function UpgradePopup({ open, anchorEl, onMouseEnter, onMouseLeave }: Props) {
    const handleClick = () => {
        window.open(pricingStudioUrl, '_blank');
    };

    return (
        <Popover
            disableRestoreFocus
            sx={{ pointerEvents: 'none' }}
            slotProps={{ paper: { sx: styles.paper, onMouseEnter, onMouseLeave } }}
            anchorOrigin={{
                vertical: -16,
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            open={open}
            anchorEl={anchorEl}>
            <Title variant="h4">Upgrade to remove watermarks</Title>
            <Typography variant="h5" fontWeight={600}>
                Watermark removal is available
                <br />
                on our paid plans.
            </Typography>
            <ButtonContainer>
                <ExploreButton onClick={handleClick}>Explore plans</ExploreButton>
            </ButtonContainer>
        </Popover>
    );
}
